var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfileWebsite = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 48,
  viewBox: "0 0 44 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 24,
  r: 22,
  fill: "#E2E4EB",
  fillOpacity: 0.6
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.2974 12.8204C15.1024 13.6051 11.0664 17.9244 10.7176 23.2501H16.4572C16.6813 19.4635 18.0218 15.8357 20.2974 12.8204ZM23.7038 12.8205C25.9793 15.8358 27.3198 19.4635 27.5439 23.2501H33.2828C32.934 17.9246 28.8984 13.6055 23.7038 12.8205ZM26.041 23.2501C25.8015 19.5197 24.3865 15.9607 22.0005 13.0849C19.6146 15.9607 18.1996 19.5197 17.9601 23.2501H26.041ZM17.9601 24.7501H26.041C25.8015 28.4805 24.3865 32.0395 22.0005 34.9154C19.6146 32.0395 18.1995 28.4805 17.9601 24.7501ZM16.4572 24.7501H10.7176C11.0663 30.0758 15.1024 34.3952 20.2974 35.1798C18.0218 32.1645 16.6812 28.5367 16.4572 24.7501ZM23.7038 35.1797C25.9793 32.1644 27.3199 28.5366 27.5439 24.7501H33.2828C32.9341 30.0755 28.8985 34.3947 23.7038 35.1797ZM22.0002 11.193C29.0734 11.193 34.8073 16.927 34.8073 24.0001C34.8073 31.0732 29.0735 36.807 22.0005 36.8072C22.0004 36.8072 22.0003 36.8072 22.0002 36.8072C14.927 36.8072 9.19312 31.0733 9.19312 24.0001V24.0001C9.19315 16.9269 14.9271 11.193 22.0002 11.193Z",
  fill: "#345DA7"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfileWebsite);
export default ForwardRef;